import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { Association } from './association.model';
import { User } from '../user/user.model';

@Injectable()
export class AssociationService extends BaseService {

  constructor(protected http: HttpClient, protected router: Router, protected cookieService: CookieService) {
    super(http, router, cookieService);
  }

  getAll(userId?: string): Observable<Association[]> {
    let params: HttpParams = new HttpParams();

    if (!!userId) {
      params = params.append('user', userId);
    }

    return this.get<Association[]>(`/associations`, this.httpOptions(params));
  }

  getAssociation(associationId: string): Observable<Association> {

    return this.get<Association>(`/associations/${ associationId }`, this.httpOptions());
  }

  getUsers(associationId: string, search?: string): Observable<User[]> {
    let params: HttpParams = new HttpParams();

    if (!!search) {
      params = params.append('search', search);
    }

    return this.get<User[]>(`/associations/${ associationId }/users`, this.httpOptions(params));
  }

  update(association: Association): Observable<Association> {
    return this.put<Association>(`/associations/${ association.id }`, association, this.httpOptions());
  }
}
